import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getAuthProps } from "../services/auth/authService";
import { getQuickServicesList, handleQuickServiceNavigation } from "../utils/quickServices/quickServices.utils";
import { useGetQuickServicesQuery } from "../app/services/CommonAPI";

export const useQuickServices = ({
  handlePortalSelect,
  apiMenus: externalMenus,
  isLoading: externalLoading,
  fallbackToFeatureConfig = true,
  skip = false,
} = {}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userData = getAuthProps();
  const isCompanyUser = Boolean(userData?.companyId);
  const isErpLoggedIn = Boolean(userData?.isErpLoggedIn);

  // Skip query if external menus are provided, user is ERP/Company user, or skip is specified
  const shouldSkip = Boolean(externalMenus) || isCompanyUser || isErpLoggedIn || skip;

  const { data: commonQueryResponse, isLoading: commonLoading } = useGetQuickServicesQuery(undefined, {
    skip: shouldSkip,
  });

  const rawMenus = externalMenus !== undefined
    ? externalMenus
    : (commonQueryResponse?.data || commonQueryResponse);

  const isLoading = externalLoading !== undefined
    ? externalLoading
    : (commonLoading && !rawMenus);

  const services = useMemo(() => {
    const menus = Array.isArray(rawMenus?.data)
      ? rawMenus.data
      : Array.isArray(rawMenus)
        ? rawMenus
        : [];
    return getQuickServicesList(menus, t, { fallbackToFeatureConfig });
  }, [rawMenus, t, fallbackToFeatureConfig]);

  const handleCardClick = (service) => {
    handleQuickServiceNavigation(service, {
      handlePortalSelect,
      navigate,
      isErpLoggedIn: userData?.isErpLoggedIn,
    });
  };

  return {
    services,
    isLoading,
    handleCardClick,
  };
};

export default useQuickServices;
